module.exports = __webpack_public_path__ + "static/img/12.8091cd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/eng/12.png
// module id = RrGT
// module chunks = 0